<template lang="pug">
.app
  van-nav-bar(
    :title="$t('activityList')"
    @click-left="onClickLeft"
    :left-text="$t('return')"
    left-arrow)
  div
    div(class="input" style="background-color: #FFFFFF;display: flex;align-items: center;justify-content: space-around;font-size: 16px;    box-sizing: border-box;box-shadow: 0 0.5em 2em -0.7em rgb(64 90 163 / 15%);" id='ln')
      van-radio-group(v-model="radio" direction="horizontal" @change="langChange")
        van-radio(name="zh") 中 文
        van-radio(name="en") English
    div(class="content" style="width: 100%;" v-loading="loading")
      el-row(style="margin-top:30px")
        el-col(:span="24" v-for="(d, index) in data" :key="d.id")
          el-card(style="margin-bottom:30px;")
            div(v-on:click="toInfo(d.id)")
              img(:src="d.url" class="image")
              //- span {{ d.url}}
              div
                span(style="font-weight: 600; font-size: 20px;" v-if="radio==='en'") {{ d.name_en }}
                span(style="font-weight: 600; font-size: 20px;" v-else) {{ d.name }}
                br
                span(style="font-weight: 400; font-size: 17px;" v-if="radio==='en'") {{$t('activityType')}}: {{ d.type_en }}
                span(style="font-weight: 400; font-size: 17px;" v-else) {{$t('activityType')}}: {{ d.type }}
                br
                span(style="font-weight: 400; font-size: 17px;") {{$t('time')}}: {{ $u.formatToDate(d.time) }}

</template>

<script>
export default {
  data: () => ({
    radio: localStorage.getItem("lang") || "zh",
    loading: false,
    data: [],
    types: [],
  }),
  computed: {
    team() {
      return this.$s.getters.team;
    },
    profile() {
      return this.$s.getters.profile;
    },
    role() {
      return this.$s.getters.profile.role[0].role;
    },
  },
  watch: {
    $route: function (to, from) {
      console.log("change route");
      this.initData();
    },
    team: function (team) {
      console.log("change team to", team.name);
      this.initData();
    },
  },
  mounted() {
    console.log("index mounted");
  },
  async created() {
    await this.doSearch();
  },
  methods: {
    langChange(e) {
      console.log(e)
      this.$nextTick(() => {
        localStorage.setItem("lang", e)
        this.$i18n.locale = e
      })
    },
    async doSearch() {
      this.loading = true
      this.$api.getTypes().then((typeRes) => {
        if (typeRes.status === 200) {
          this.types = typeRes.data.data
          this.$api.getActivitys().then(async (res) => {
            if (res.status === 200) {
              console.log(res.data);
              var data = res.data.data;
              for(let i=0; i<data.length; i++) {
                //获取图片地址
                var image = await this.$api.getImage(data[i].url)
                if (image.status === 200) {
                  data[i].url = image.data.data.url
                }
                //给类型赋值名称和英文名称
                for(let j=0; j<this.types.length; j++) {
                  var types = this.types[j]
                  if (types.id === data[i].type) {
                    data[i].type = types.name
                    data[i].type_en = types.name_en
                  }
                }
              }
              this.data = data
            }
            this.loading = false
          }).catch((err)=> {
            this.loading = false
          })
        }
      })
    },
    onClickLeft() {
      this.$router.back();
    },
    toInfo(id) {
      this.$router.push({ name: "activity_info", params: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  height: 37px;
  line-height: 37px;
  border: 0px;
  color: #333333;
  font-size: 16px;
  background-color: #efefef;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
